import React, { FC, useEffect, useRef } from 'react'

import { AnimatePresence, motion } from 'motion/react'

import {
  getVerticalSlideTransition,
  verticalSlideVariants
} from '../../animation'
import { VerticalSlideProps } from './VerticalSlide.types'

export const VerticalSlide: FC<VerticalSlideProps> = ({
  animateOnMount = true,
  className,
  children,
  direction,
  duration,
  onAnimationComplete,
  slideKey
}) => {
  const hasMounted = useRef(false)
  const shouldAnimateEntry = animateOnMount || hasMounted.current

  useEffect(() => {
    hasMounted.current = true
  }, [])

  return (
    <AnimatePresence mode='wait' custom={direction}>
      <motion.div
        key={slideKey}
        custom={direction}
        variants={verticalSlideVariants}
        initial={shouldAnimateEntry ? 'enter' : false}
        animate='center'
        exit='exit'
        transition={getVerticalSlideTransition(duration)}
        className={className}
        onAnimationComplete={onAnimationComplete}
      >
        {children}
      </motion.div>
    </AnimatePresence>
  )
}
